import {
  defineComponent, ref,
} from 'vue';
import { VAutocomplete } from 'vuetify/components';
import { ApiConsentClient } from '@src/testpage/clients/ApiConsentClient.js';
import { wrapInSuspense } from '@src/testpage/components/helpers/wrapInSuspense.js';
import html from './MfeServiceProviderSelect.html'; // eslint-disable-line no-restricted-imports

export interface ServiceProvider {
  id: string;
  description: string;
}

type VuetifyItemsType = { title: string, value: string; };

// Needs to be wrapped in <Suspense> because setup() is async
export const MfeServiceProviderSelect = wrapInSuspense(defineComponent({
  name: 'MfeServiceProviderSelect',
  components: {
    VAutocomplete,
  },
  template: html,
  props: {
    value: String,
  },
  emits: ['change'],
  async setup(props) {
    const spId = ref<string>(props.value!);
    const apiConsentClient = await ApiConsentClient.create();
    const serviceProvidersData = await apiConsentClient.get<ServiceProvider[]>('/service/serviceproviders');

    const serviceProviders = ref<VuetifyItemsType[]>([]);
    serviceProviders.value = serviceProvidersData.map((sp) => ({
      value: sp.id,
      title: `${sp.id} (${sp.description})`,
    }));

    return { serviceProviders, spId };
  },
}));
